import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import { useTheme, Box } from "@achieve/ascend";
import { useRef, useState, useEffect, useLayoutEffect } from "react";
import { css } from "@emotion/react";
const DataSectionTest = {
  achieveOffer: {
    totalCost: 30668,
    monthlyPayment: 639,
    years: 4
  },
  currentOffer: {
    totalCost: 57452.05,
    monthlyPayment: 1019.73,
    years: 57 / 12
  },
  waitOffer: {
    totalCost: 67522.33,
    monthlyPayment: 1198.48,
    years: 57 / 12
  },
  current_assessment: {
    cfos: {
      payoff_info: {
        amortization: false,
        blended_interest_rate: 22.77,
        budget: {
          apply_budget: false,
          is_budget_valid: false,
          monthly_budget: 0
        },
        cerebro_pid: "dummy_cerebro",
        plan_start_date: "2023-12-14",
        request_id: "",
        request_schema_ver: "20231029cfos2",
        strategies: ["FIXED"],
        tradelines: [{
          account_type: "",
          balance: 3e4,
          balance_date: "",
          credit_limit: 0,
          creditor: {
            kob: "",
            name: "",
            subscriber_code: ""
          },
          debt_calculation: {
            balance: 3e4,
            calculation_type: "REVOLVING",
            errors: [],
            interest_rate: 22.77,
            is_monthly_payment_valid: false,
            monthly_payment_updated: true,
            terms: 0,
            updated_monthly_payment: 0,
            warnings: []
          },
          enhanced_payment_data: {
            account_condition: "",
            account_type: "",
            initial_payment_level_date: "",
            payment_status: "",
            special_comment_code: ""
          },
          high_credit: 0,
          id: "1",
          is_open: false,
          monthly_payment: 874.57,
          most_recent_delinquency_date: "",
          original_amount: 0,
          revolving_or_installment: "R",
          rule_data: {
            category: "credit_card_default",
            interest_rate: 22.77,
            is_collections: false,
            is_delinquent: false,
            is_valid_tradeline: true,
            min_monthly_payment: 35,
            principal_paydown_percentage: 1,
            revolving_or_installment: "R",
            terms_months: 0
          },
          terms: 0
        }]
      },
      payoff_plans: [{
        payoff: [],
        starting_total_monthly_payment: 874.57,
        strategy_type: "FIXED",
        time_in_months: 57,
        total_amount: 49318.54,
        total_interest: 19318.54,
        tradeline_payoff: [{
          amount: 49318.54,
          id: "1",
          interest: 19318.54,
          interest_rate_used: 22.77,
          monthly_payment: 874.57,
          principal: 3e4,
          time_in_months: 57
        }]
      }]
    }
  },
  default_offers: {
    ahl_offers: [{
      amount: 3e4,
      monthly_payment: 434.76,
      rate: 12.25,
      terms: 120,
      terms_category: "",
      total_cost: 52171
    }],
    apl_offers: [{
      amount: 3e4,
      monthly_payment: 1534.06,
      rate: 28.21,
      terms: 24,
      terms_category: "24",
      total_cost: 36817
    }, {
      amount: 3e4,
      monthly_payment: 1122.41,
      rate: 25.06,
      terms: 36,
      terms_category: "36",
      total_cost: 40407
    }, {
      amount: 3e4,
      monthly_payment: 961.38,
      rate: 27.32,
      terms: 48,
      terms_category: "48",
      total_cost: 46146
    }, {
      amount: 3e4,
      monthly_payment: 884.77,
      rate: 28.94,
      terms: 60,
      terms_category: "60",
      total_cost: 53086
    }],
    ar_offers: [{
      amount: 3e4,
      monthly_payment: 901,
      rate: null,
      terms: 24,
      terms_category: "offer1",
      total_cost: 21615
    }, {
      amount: 3e4,
      monthly_payment: 549,
      rate: null,
      terms: 48,
      terms_category: "offer2",
      total_cost: 26355
    }, {
      amount: 3e4,
      monthly_payment: 554,
      rate: null,
      terms: 49,
      terms_category: "offer3",
      total_cost: 27376
    }]
  },
  projected_assessment: {
    cfos: {
      payoff_info: {
        amortization: false,
        blended_interest_rate: 22.77,
        budget: {
          apply_budget: false,
          is_budget_valid: false,
          monthly_budget: 0
        },
        cerebro_pid: "dummy_cerebro",
        plan_start_date: "2023-12-14",
        request_id: "",
        request_schema_ver: "20231029cfos2",
        strategies: ["FIXED"],
        tradelines: [{
          account_type: "",
          balance: 35194,
          balance_date: "",
          credit_limit: 0,
          creditor: {
            kob: "",
            name: "",
            subscriber_code: ""
          },
          debt_calculation: {
            balance: 35194,
            calculation_type: "REVOLVING",
            errors: [],
            interest_rate: 22.77,
            is_monthly_payment_valid: false,
            monthly_payment_updated: true,
            terms: 0,
            updated_monthly_payment: 0,
            warnings: []
          },
          enhanced_payment_data: {
            account_condition: "",
            account_type: "",
            initial_payment_level_date: "",
            payment_status: "",
            special_comment_code: ""
          },
          high_credit: 0,
          id: "1",
          is_open: false,
          monthly_payment: 1025.98,
          most_recent_delinquency_date: "",
          original_amount: 0,
          revolving_or_installment: "R",
          rule_data: {
            category: "credit_card_default",
            interest_rate: 22.77,
            is_collections: false,
            is_delinquent: false,
            is_valid_tradeline: true,
            min_monthly_payment: 35,
            principal_paydown_percentage: 1,
            revolving_or_installment: "R",
            terms_months: 0
          },
          terms: 0
        }]
      },
      payoff_plans: [{
        payoff: [],
        starting_total_monthly_payment: 1025.98,
        strategy_type: "FIXED",
        time_in_months: 57,
        total_amount: 57857.56,
        total_interest: 22663.56,
        tradeline_payoff: [{
          amount: 57857.56,
          id: "1",
          interest: 22663.56,
          interest_rate_used: 22.77,
          monthly_payment: 1025.98,
          principal: 35194,
          time_in_months: 57
        }]
      }]
    },
    projected_increase: {
      estimated_debt: 3e4,
      projected_debt: 35194,
      projected_increase: 5194,
      rounded_estimated_debt: 3e4
    }
  }
};
const numberFormatCurrency = (value) => {
  return "$" + new Intl.NumberFormat("en-US").format(value || 0);
};
const numberFormatThousands = (value) => {
  return `${Math.round(value / 1e3)}K`;
};
function ascending$1(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
function descending(a, b) {
  return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}
function bisector(f) {
  let compare1, compare2, delta;
  if (f.length !== 2) {
    compare1 = ascending$1;
    compare2 = (d, x2) => ascending$1(f(d), x2);
    delta = (d, x2) => f(d) - x2;
  } else {
    compare1 = f === ascending$1 || f === descending ? f : zero$1;
    compare2 = f;
    delta = f;
  }
  function left2(a, x2, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a[mid], x2) < 0)
          lo = mid + 1;
        else
          hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right2(a, x2, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a[mid], x2) <= 0)
          lo = mid + 1;
        else
          hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center2(a, x2, lo = 0, hi = a.length) {
    const i = left2(a, x2, lo, hi - 1);
    return i > lo && delta(a[i - 1], x2) > -delta(a[i], x2) ? i - 1 : i;
  }
  return { left: left2, center: center2, right: right2 };
}
function zero$1() {
  return 0;
}
function number$2(x2) {
  return x2 === null ? NaN : +x2;
}
const ascendingBisect = bisector(ascending$1);
const bisectRight = ascendingBisect.right;
bisector(number$2).center;
const bisect = bisectRight;
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start2, stop, count) {
  const step = (stop - start2) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start2 * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start2)
      ++i1;
    if (i2 / inc > stop)
      --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start2 / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start2)
      ++i1;
    if (i2 * inc > stop)
      --i2;
  }
  if (i2 < i1 && 0.5 <= count && count < 2)
    return tickSpec(start2, stop, count * 2);
  return [i1, i2, inc];
}
function ticks(start2, stop, count) {
  stop = +stop, start2 = +start2, count = +count;
  if (!(count > 0))
    return [];
  if (start2 === stop)
    return [start2];
  const reverse = stop < start2, [i1, i2, inc] = reverse ? tickSpec(stop, start2, count) : tickSpec(start2, stop, count);
  if (!(i2 >= i1))
    return [];
  const n = i2 - i1 + 1, ticks2 = new Array(n);
  if (reverse) {
    if (inc < 0)
      for (let i = 0; i < n; ++i)
        ticks2[i] = (i2 - i) / -inc;
    else
      for (let i = 0; i < n; ++i)
        ticks2[i] = (i2 - i) * inc;
  } else {
    if (inc < 0)
      for (let i = 0; i < n; ++i)
        ticks2[i] = (i1 + i) / -inc;
    else
      for (let i = 0; i < n; ++i)
        ticks2[i] = (i1 + i) * inc;
  }
  return ticks2;
}
function tickIncrement(start2, stop, count) {
  stop = +stop, start2 = +start2, count = +count;
  return tickSpec(start2, stop, count)[2];
}
function tickStep(start2, stop, count) {
  stop = +stop, start2 = +start2, count = +count;
  const reverse = stop < start2, inc = reverse ? tickIncrement(stop, start2, count) : tickIncrement(start2, stop, count);
  return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}
function max(values, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function identity$3(x2) {
  return x2;
}
var top = 1, right = 2, bottom = 3, left = 4, epsilon$1 = 1e-6;
function translateX(x2) {
  return "translate(" + x2 + ",0)";
}
function translateY(y2) {
  return "translate(0," + y2 + ")";
}
function number$1(scale) {
  return (d) => +scale(d);
}
function center(scale, offset) {
  offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
  if (scale.round())
    offset = Math.round(offset);
  return (d) => +scale(d) + offset;
}
function entering() {
  return !this.__axis;
}
function axis(orient, scale) {
  var tickArguments = [], tickValues = null, tickFormat2 = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x2 = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
  function axis2(context) {
    var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format2 = tickFormat2 == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$3 : tickFormat2, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? center : number$1)(scale.copy(), offset), selection2 = context.selection ? context.selection() : context, path = selection2.selectAll(".domain").data([null]), tick = selection2.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line2 = tick.select("line"), text = tick.select("text");
    path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
    tick = tick.merge(tickEnter);
    line2 = line2.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x2 + "2", k * tickSizeInner));
    text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x2, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
    if (context !== selection2) {
      path = path.transition(context);
      tick = tick.transition(context);
      line2 = line2.transition(context);
      text = text.transition(context);
      tickExit = tickExit.transition(context).attr("opacity", epsilon$1).attr("transform", function(d) {
        return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
      });
      tickEnter.attr("opacity", epsilon$1).attr("transform", function(d) {
        var p = this.parentNode.__axis;
        return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
      });
    }
    tickExit.remove();
    path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
    tick.attr("opacity", 1).attr("transform", function(d) {
      return transform(position(d) + offset);
    });
    line2.attr(x2 + "2", k * tickSizeInner);
    text.attr(x2, k * spacing).text(format2);
    selection2.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
    selection2.each(function() {
      this.__axis = position;
    });
  }
  axis2.scale = function(_) {
    return arguments.length ? (scale = _, axis2) : scale;
  };
  axis2.ticks = function() {
    return tickArguments = Array.from(arguments), axis2;
  };
  axis2.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis2) : tickArguments.slice();
  };
  axis2.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis2) : tickValues && tickValues.slice();
  };
  axis2.tickFormat = function(_) {
    return arguments.length ? (tickFormat2 = _, axis2) : tickFormat2;
  };
  axis2.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis2) : tickSizeInner;
  };
  axis2.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis2) : tickSizeInner;
  };
  axis2.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis2) : tickSizeOuter;
  };
  axis2.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis2) : tickPadding;
  };
  axis2.offset = function(_) {
    return arguments.length ? (offset = +_, axis2) : offset;
  };
  return axis2;
}
function axisRight(scale) {
  return axis(right, scale);
}
function axisBottom(scale) {
  return axis(bottom, scale);
}
function axisLeft(scale) {
  return axis(left, scale);
}
var noop = { value: () => {
} };
function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t))
      throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}
function Dispatch(_) {
  this._ = _;
}
function parseTypenames$1(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0)
      name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    return { type: t, name };
  });
}
Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._, T = parseTypenames$1(typename + "", _), t, i = -1, n = T.length;
    if (arguments.length < 2) {
      while (++i < n)
        if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name)))
          return t;
      return;
    }
    if (callback != null && typeof callback !== "function")
      throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type)
        _[t] = set$1(_[t], typename.name, callback);
      else if (callback == null)
        for (t in _)
          _[t] = set$1(_[t], typename.name, null);
    }
    return this;
  },
  copy: function() {
    var copy2 = {}, _ = this._;
    for (var t in _)
      copy2[t] = _[t].slice();
    return new Dispatch(copy2);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0)
      for (var args = new Array(n), i = 0, n, t; i < n; ++i)
        args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type))
      throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i)
      t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type))
      throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i)
      t[i].value.apply(that, args);
  }
};
function get$1(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}
function set$1(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null)
    type.push({ name, value: callback });
  return type;
}
var xhtml = "http://www.w3.org/1999/xhtml";
const namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns")
    name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? { space: namespaces[prefix], local: name } : name;
}
function creatorInherit(name) {
  return function() {
    var document2 = this.ownerDocument, uri = this.namespaceURI;
    return uri === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri, name);
  };
}
function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}
function creator(name) {
  var fullname = namespace(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}
function none() {
}
function selector(selector2) {
  return selector2 == null ? none : function() {
    return this.querySelector(selector2);
  };
}
function selection_select(select2) {
  if (typeof select2 !== "function")
    select2 = selector(select2);
  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select2.call(node, node.__data__, i, group))) {
        if ("__data__" in node)
          subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }
  return new Selection$1(subgroups, this._parents);
}
function array$1(x2) {
  return x2 == null ? [] : Array.isArray(x2) ? x2 : Array.from(x2);
}
function empty() {
  return [];
}
function selectorAll(selector2) {
  return selector2 == null ? empty : function() {
    return this.querySelectorAll(selector2);
  };
}
function arrayAll(select2) {
  return function() {
    return array$1(select2.apply(this, arguments));
  };
}
function selection_selectAll(select2) {
  if (typeof select2 === "function")
    select2 = arrayAll(select2);
  else
    select2 = selectorAll(select2);
  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select2.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }
  return new Selection$1(subgroups, parents);
}
function matcher(selector2) {
  return function() {
    return this.matches(selector2);
  };
}
function childMatcher(selector2) {
  return function(node) {
    return node.matches(selector2);
  };
}
var find = Array.prototype.find;
function childFind(match) {
  return function() {
    return find.call(this.children, match);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selection_selectChild(match) {
  return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
}
var filter = Array.prototype.filter;
function children() {
  return Array.from(this.children);
}
function childrenFilter(match) {
  return function() {
    return filter.call(this.children, match);
  };
}
function selection_selectChildren(match) {
  return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}
function selection_filter(match) {
  if (typeof match !== "function")
    match = matcher(match);
  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }
  return new Selection$1(subgroups, this._parents);
}
function sparse(update) {
  return new Array(update.length);
}
function selection_enter() {
  return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
}
function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) {
    return this._parent.insertBefore(child, this._next);
  },
  insertBefore: function(child, next) {
    return this._parent.insertBefore(child, next);
  },
  querySelector: function(selector2) {
    return this._parent.querySelector(selector2);
  },
  querySelectorAll: function(selector2) {
    return this._parent.querySelectorAll(selector2);
  }
};
function constant$2(x2) {
  return function() {
    return x2;
  };
}
function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0, node, groupLength = group.length, dataLength = data.length;
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}
function bindKey(parent, group, enter, update, exit, data, key) {
  var i, node, nodeByKeyValue = /* @__PURE__ */ new Map(), groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) {
      exit[i] = node;
    }
  }
}
function datum(node) {
  return node.__data__;
}
function selection_data(value, key) {
  if (!arguments.length)
    return Array.from(this, datum);
  var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
  if (typeof value !== "function")
    value = constant$2(value);
  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1)
          i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength)
          ;
        previous._next = next || null;
      }
    }
  }
  update = new Selection$1(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}
function arraylike(data) {
  return typeof data === "object" && "length" in data ? data : Array.from(data);
}
function selection_exit() {
  return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
}
function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  if (typeof onenter === "function") {
    enter = onenter(enter);
    if (enter)
      enter = enter.selection();
  } else {
    enter = enter.append(onenter + "");
  }
  if (onupdate != null) {
    update = onupdate(update);
    if (update)
      update = update.selection();
  }
  if (onexit == null)
    exit.remove();
  else
    onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}
function selection_merge(context) {
  var selection2 = context.selection ? context.selection() : context;
  for (var groups0 = this._groups, groups1 = selection2._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Selection$1(merges, this._parents);
}
function selection_order() {
  for (var groups = this._groups, j = -1, m = groups.length; ++j < m; ) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4)
          next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }
  return this;
}
function selection_sort(compare) {
  if (!compare)
    compare = ascending;
  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }
  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }
  return new Selection$1(sortgroups, this._parents).order();
}
function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}
function selection_nodes() {
  return Array.from(this);
}
function selection_node() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node)
        return node;
    }
  }
  return null;
}
function selection_size() {
  let size = 0;
  for (const node of this)
    ++size;
  return size;
}
function selection_empty() {
  return !this.node();
}
function selection_each(callback) {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i])
        callback.call(node, node.__data__, i, group);
    }
  }
  return this;
}
function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant$1(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}
function attrConstantNS$1(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}
function attrFunction$1(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null)
      this.removeAttribute(name);
    else
      this.setAttribute(name, v);
  };
}
function attrFunctionNS$1(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null)
      this.removeAttributeNS(fullname.space, fullname.local);
    else
      this.setAttributeNS(fullname.space, fullname.local, v);
  };
}
function selection_attr(name, value) {
  var fullname = namespace(name);
  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
  }
  return this.each((value == null ? fullname.local ? attrRemoveNS$1 : attrRemove$1 : typeof value === "function" ? fullname.local ? attrFunctionNS$1 : attrFunction$1 : fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, value));
}
function defaultView(node) {
  return node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView;
}
function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant$1(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}
function styleFunction$1(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null)
      this.style.removeProperty(name);
    else
      this.style.setProperty(name, v, priority);
  };
}
function selection_style(name, value, priority) {
  return arguments.length > 1 ? this.each((value == null ? styleRemove$1 : typeof value === "function" ? styleFunction$1 : styleConstant$1)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
}
function styleValue(node, name) {
  return node.style.getPropertyValue(name) || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}
function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}
function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null)
      delete this[name];
    else
      this[name] = v;
  };
}
function selection_property(name, value) {
  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
}
function classArray(string) {
  return string.trim().split(/^|\s+/);
}
function classList(node) {
  return node.classList || new ClassList(node);
}
function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};
function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n)
    list.add(names[i]);
}
function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n)
    list.remove(names[i]);
}
function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}
function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}
function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}
function selection_classed(name, value) {
  var names = classArray(name + "");
  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n)
      if (!list.contains(names[i]))
        return false;
    return true;
  }
  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
}
function textRemove() {
  this.textContent = "";
}
function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction$1(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}
function selection_text(value) {
  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction$1 : textConstant$1)(value)) : this.node().textContent;
}
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}
function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}
function selection_html(value) {
  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
}
function raise() {
  if (this.nextSibling)
    this.parentNode.appendChild(this);
}
function selection_raise() {
  return this.each(raise);
}
function lower() {
  if (this.previousSibling)
    this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function selection_lower() {
  return this.each(lower);
}
function selection_append(name) {
  var create2 = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create2.apply(this, arguments));
  });
}
function constantNull() {
  return null;
}
function selection_insert(name, before) {
  var create2 = typeof name === "function" ? name : creator(name), select2 = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create2.apply(this, arguments), select2.apply(this, arguments) || null);
  });
}
function remove() {
  var parent = this.parentNode;
  if (parent)
    parent.removeChild(this);
}
function selection_remove() {
  return this.each(remove);
}
function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}
function selection_datum(value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}
function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0)
      name = t.slice(i + 1), t = t.slice(0, i);
    return { type: t, name };
  });
}
function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on)
      return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i)
      on.length = i;
    else
      delete this.__on;
  };
}
function onAdd(typename, value, options) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on)
      for (var j = 0, m = on.length; j < m; ++j) {
        if ((o = on[j]).type === typename.type && o.name === typename.name) {
          this.removeEventListener(o.type, o.listener, o.options);
          this.addEventListener(o.type, o.listener = listener, o.options = options);
          o.value = value;
          return;
        }
      }
    this.addEventListener(typename.type, listener, options);
    o = { type: typename.type, name: typename.name, value, listener, options };
    if (!on)
      this.__on = [o];
    else
      on.push(o);
  };
}
function selection_on(typename, value, options) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on)
      for (var j = 0, m = on.length, o; j < m; ++j) {
        for (i = 0, o = on[j]; i < n; ++i) {
          if ((t = typenames[i]).type === o.type && t.name === o.name) {
            return o.value;
          }
        }
      }
    return;
  }
  on = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i)
    this.each(on(typenames[i], value, options));
  return this;
}
function dispatchEvent(node, type, params) {
  var window2 = defaultView(node), event = window2.CustomEvent;
  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window2.document.createEvent("Event");
    if (params)
      event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else
      event.initEvent(type, false, false);
  }
  node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}
function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}
function selection_dispatch(type, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
}
function* selection_iterator() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i])
        yield node;
    }
  }
}
var root = [null];
function Selection$1(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}
function selection() {
  return new Selection$1([[document.documentElement]], root);
}
function selection_selection() {
  return this;
}
Selection$1.prototype = selection.prototype = {
  constructor: Selection$1,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};
function select(selector2) {
  return typeof selector2 === "string" ? new Selection$1([[document.querySelector(selector2)]], [document.documentElement]) : new Selection$1([[selector2]], root);
}
function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition)
    prototype[key] = definition[key];
  return prototype;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m, l;
  format2 = (format2 + "").trim().toLowerCase();
  return (m = reHex.exec(format2)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, (m & 15) << 4 | m & 15, 1) : l === 8 ? rgba(m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, (m & 255) / 255) : l === 4 ? rgba(m >> 12 & 15 | m >> 8 & 240, m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, ((m & 15) << 4 | m & 15) / 255) : null) : (m = reRgbInteger.exec(format2)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format2)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format2)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format2)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format2)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format2)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba(r, g, b, a) {
  if (a <= 0)
    r = g = b = NaN;
  return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color))
    o = color(o);
  if (!o)
    return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define(Rgb, rgb, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0)
    h = s = l = NaN;
  else if (l <= 0 || l >= 1)
    h = s = NaN;
  else if (s <= 0)
    h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl)
    return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color))
    o = color(o);
  if (!o)
    return new Hsl();
  if (o instanceof Hsl)
    return o;
  o = o.rgb();
  var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max2 = Math.max(r, g, b), h = NaN, s = max2 - min, l = (max2 + min) / 2;
  if (s) {
    if (r === max2)
      h = (g - b) / s + (g < b) * 6;
    else if (g === max2)
      h = (b - r) / s + 2;
    else
      h = (r - g) / s + 4;
    s /= l < 0.5 ? max2 + min : 2 - max2 - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}
const constant$1 = (x2) => () => x2;
function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}
function exponential(a, b, y2) {
  return a = Math.pow(a, y2), b = Math.pow(b, y2) - a, y2 = 1 / y2, function(t) {
    return Math.pow(a + t * b, y2);
  };
}
function gamma(y2) {
  return (y2 = +y2) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y2) : constant$1(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$1(isNaN(a) ? b : a);
}
const interpolateRgb = function rgbGamma(y2) {
  var color2 = gamma(y2);
  function rgb$1(start2, end) {
    var r = color2((start2 = rgb(start2)).r, (end = rgb(end)).r), g = color2(start2.g, end.g), b = color2(start2.b, end.b), opacity = nogamma(start2.opacity, end.opacity);
    return function(t) {
      start2.r = r(t);
      start2.g = g(t);
      start2.b = b(t);
      start2.opacity = opacity(t);
      return start2 + "";
    };
  }
  rgb$1.gamma = rgbGamma;
  return rgb$1;
}(1);
function numberArray(a, b) {
  if (!b)
    b = [];
  var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
  return function(t) {
    for (i = 0; i < n; ++i)
      c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}
function isNumberArray(x2) {
  return ArrayBuffer.isView(x2) && !(x2 instanceof DataView);
}
function genericArray(a, b) {
  var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x2 = new Array(na), c = new Array(nb), i;
  for (i = 0; i < na; ++i)
    x2[i] = interpolate$1(a[i], b[i]);
  for (; i < nb; ++i)
    c[i] = b[i];
  return function(t) {
    for (i = 0; i < na; ++i)
      c[i] = x2[i](t);
    return c;
  };
}
function date(a, b) {
  var d = new Date();
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}
function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}
function object(a, b) {
  var i = {}, c = {}, k;
  if (a === null || typeof a !== "object")
    a = {};
  if (b === null || typeof b !== "object")
    b = {};
  for (k in b) {
    if (k in a) {
      i[k] = interpolate$1(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function(t) {
    for (k in i)
      c[k] = i[k](t);
    return c;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
  return function() {
    return b;
  };
}
function one(b) {
  return function(t) {
    return b(t) + "";
  };
}
function interpolateString(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
  a = a + "", b = b + "";
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s[i])
        s[i] += bs;
      else
        s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s[i])
        s[i] += bm;
      else
        s[++i] = bm;
    } else {
      s[++i] = null;
      q.push({ i, x: interpolateNumber(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i])
      s[i] += bs;
    else
      s[++i] = bs;
  }
  return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
    for (var i2 = 0, o; i2 < b; ++i2)
      s[(o = q[i2]).i] = o.x(t);
    return s.join("");
  });
}
function interpolate$1(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$1(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color(b)) ? (b = c, interpolateRgb) : interpolateString : b instanceof color ? interpolateRgb : b instanceof Date ? date : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : interpolateNumber)(a, b);
}
function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}
var degrees = 180 / Math.PI;
var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b))
    a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d)
    c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d))
    c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c)
    a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX,
    scaleY
  };
}
var svgNode;
function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? identity$2 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
  if (value == null)
    return identity$2;
  if (!svgNode)
    svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate()))
    return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}
function interpolateTransform(parse, pxComma, pxParen, degParen) {
  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }
  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({ i: i - 4, x: interpolateNumber(xa, xb) }, { i: i - 2, x: interpolateNumber(ya, yb) });
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }
  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180)
        b += 360;
      else if (b - a > 180)
        a += 360;
      q.push({ i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber(a, b) });
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }
  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({ i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber(a, b) });
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }
  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({ i: i - 4, x: interpolateNumber(xa, xb) }, { i: i - 2, x: interpolateNumber(ya, yb) });
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }
  return function(a, b) {
    var s = [], q = [];
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n)
        s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}
var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
var frame = 0, timeout$1 = 0, interval = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
  setTimeout(f, 17);
};
function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer() {
  this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function")
      throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail)
        taskTail._next = this;
      else
        taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};
function timer(callback, delay, time) {
  var t = new Timer();
  t.restart(callback, delay, time);
  return t;
}
function timerFlush() {
  now();
  ++frame;
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0)
      t._call.call(void 0, e);
    t = t._next;
  }
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}
function poke() {
  var now2 = clock.now(), delay = now2 - clockLast;
  if (delay > pokeDelay)
    clockSkew -= delay, clockLast = now2;
}
function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time)
        time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}
function sleep(time) {
  if (frame)
    return;
  if (timeout$1)
    timeout$1 = clearTimeout(timeout$1);
  var delay = time - clockNow;
  if (delay > 24) {
    if (time < Infinity)
      timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval)
      interval = clearInterval(interval);
  } else {
    if (!interval)
      clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}
function timeout(callback, delay, time) {
  var t = new Timer();
  delay = delay == null ? 0 : +delay;
  t.restart((elapsed) => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}
var emptyOn = dispatch("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function schedule(node, name, id2, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules)
    node.__transition = {};
  else if (id2 in schedules)
    return;
  create(node, id2, {
    name,
    index,
    group,
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}
function init(node, id2) {
  var schedule2 = get(node, id2);
  if (schedule2.state > CREATED)
    throw new Error("too late; already scheduled");
  return schedule2;
}
function set(node, id2) {
  var schedule2 = get(node, id2);
  if (schedule2.state > STARTED)
    throw new Error("too late; already running");
  return schedule2;
}
function get(node, id2) {
  var schedule2 = node.__transition;
  if (!schedule2 || !(schedule2 = schedule2[id2]))
    throw new Error("transition not found");
  return schedule2;
}
function create(node, id2, self) {
  var schedules = node.__transition, tween;
  schedules[id2] = self;
  self.timer = timer(schedule2, 0, self.time);
  function schedule2(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start2, self.delay, self.time);
    if (self.delay <= elapsed)
      start2(elapsed - self.delay);
  }
  function start2(elapsed) {
    var i, j, n, o;
    if (self.state !== SCHEDULED)
      return stop();
    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name)
        continue;
      if (o.state === STARTED)
        return timeout(start2);
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      } else if (+i < id2) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }
    timeout(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING)
      return;
    self.state = STARTED;
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }
  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
    while (++i < n) {
      tween[i].call(node, t);
    }
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }
  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id2];
    for (var i in schedules)
      return;
    delete node.__transition;
  }
}
function interrupt(node, name) {
  var schedules = node.__transition, schedule2, active, empty2 = true, i;
  if (!schedules)
    return;
  name = name == null ? null : name + "";
  for (i in schedules) {
    if ((schedule2 = schedules[i]).name !== name) {
      empty2 = false;
      continue;
    }
    active = schedule2.state > STARTING && schedule2.state < ENDING;
    schedule2.state = ENDED;
    schedule2.timer.stop();
    schedule2.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule2.index, schedule2.group);
    delete schedules[i];
  }
  if (empty2)
    delete node.__transition;
}
function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}
function tweenRemove(id2, name) {
  var tween0, tween1;
  return function() {
    var schedule2 = set(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }
    schedule2.tween = tween1;
  };
}
function tweenFunction(id2, name, value) {
  var tween0, tween1;
  if (typeof value !== "function")
    throw new Error();
  return function() {
    var schedule2 = set(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = { name, value }, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n)
        tween1.push(t);
    }
    schedule2.tween = tween1;
  };
}
function transition_tween(name, value) {
  var id2 = this._id;
  name += "";
  if (arguments.length < 2) {
    var tween = get(this.node(), id2).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }
  return this.each((value == null ? tweenRemove : tweenFunction)(id2, name, value));
}
function tweenValue(transition, name, value) {
  var id2 = transition._id;
  transition.each(function() {
    var schedule2 = set(this, id2);
    (schedule2.value || (schedule2.value = {}))[name] = value.apply(this, arguments);
  });
  return function(node) {
    return get(node, id2).value[name];
  };
}
function interpolate(a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c = color(b)) ? (b = c, interpolateRgb) : interpolateString)(a, b);
}
function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrConstantNS(fullname, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrFunction(name, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null)
      return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function attrFunctionNS(fullname, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null)
      return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate;
  return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
}
function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}
function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}
function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0)
      t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}
function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0)
      t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}
function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2)
    return (key = this.tween(key)) && key._value;
  if (value == null)
    return this.tween(key, null);
  if (typeof value !== "function")
    throw new Error();
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}
function delayFunction(id2, value) {
  return function() {
    init(this, id2).delay = +value.apply(this, arguments);
  };
}
function delayConstant(id2, value) {
  return value = +value, function() {
    init(this, id2).delay = value;
  };
}
function transition_delay(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id2, value)) : get(this.node(), id2).delay;
}
function durationFunction(id2, value) {
  return function() {
    set(this, id2).duration = +value.apply(this, arguments);
  };
}
function durationConstant(id2, value) {
  return value = +value, function() {
    set(this, id2).duration = value;
  };
}
function transition_duration(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id2, value)) : get(this.node(), id2).duration;
}
function easeConstant(id2, value) {
  if (typeof value !== "function")
    throw new Error();
  return function() {
    set(this, id2).ease = value;
  };
}
function transition_ease(value) {
  var id2 = this._id;
  return arguments.length ? this.each(easeConstant(id2, value)) : get(this.node(), id2).ease;
}
function easeVarying(id2, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (typeof v !== "function")
      throw new Error();
    set(this, id2).ease = v;
  };
}
function transition_easeVarying(value) {
  if (typeof value !== "function")
    throw new Error();
  return this.each(easeVarying(this._id, value));
}
function transition_filter(match) {
  if (typeof match !== "function")
    match = matcher(match);
  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }
  return new Transition(subgroups, this._parents, this._name, this._id);
}
function transition_merge(transition) {
  if (transition._id !== this._id)
    throw new Error();
  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Transition(merges, this._parents, this._name, this._id);
}
function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0)
      t = t.slice(0, i);
    return !t || t === "start";
  });
}
function onFunction(id2, name, listener) {
  var on0, on1, sit = start(name) ? init : set;
  return function() {
    var schedule2 = sit(this, id2), on = schedule2.on;
    if (on !== on0)
      (on1 = (on0 = on).copy()).on(name, listener);
    schedule2.on = on1;
  };
}
function transition_on(name, listener) {
  var id2 = this._id;
  return arguments.length < 2 ? get(this.node(), id2).on.on(name) : this.each(onFunction(id2, name, listener));
}
function removeFunction(id2) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition)
      if (+i !== id2)
        return;
    if (parent)
      parent.removeChild(this);
  };
}
function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}
function transition_select(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function")
    select2 = selector(select2);
  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select2.call(node, node.__data__, i, group))) {
        if ("__data__" in node)
          subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id2, i, subgroup, get(node, id2));
      }
    }
  }
  return new Transition(subgroups, this._parents, name, id2);
}
function transition_selectAll(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function")
    select2 = selectorAll(select2);
  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children2 = select2.call(node, node.__data__, i, group), child, inherit2 = get(node, id2), k = 0, l = children2.length; k < l; ++k) {
          if (child = children2[k]) {
            schedule(child, name, id2, k, children2, inherit2);
          }
        }
        subgroups.push(children2);
        parents.push(node);
      }
    }
  }
  return new Transition(subgroups, parents, name, id2);
}
var Selection = selection.prototype.constructor;
function transition_selection() {
  return new Selection(this._groups, this._parents);
}
function styleNull(name, interpolate2) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, string10 = string1);
  };
}
function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function styleFunction(name, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
    if (value1 == null)
      string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function styleMaybeRemove(id2, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove2;
  return function() {
    var schedule2 = set(this, id2), on = schedule2.on, listener = schedule2.value[key] == null ? remove2 || (remove2 = styleRemove(name)) : void 0;
    if (on !== on0 || listener0 !== listener)
      (on1 = (on0 = on).copy()).on(event, listener0 = listener);
    schedule2.on = on1;
  };
}
function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
  return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
}
function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}
function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0)
      t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}
function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2)
    return (key = this.tween(key)) && key._value;
  if (value == null)
    return this.tween(key, null);
  if (typeof value !== "function")
    throw new Error();
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}
function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}
function transition_text(value) {
  return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
}
function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}
function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0)
      t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}
function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1)
    return (key = this.tween(key)) && key._value;
  if (value == null)
    return this.tween(key, null);
  if (typeof value !== "function")
    throw new Error();
  return this.tween(key, textTween(value));
}
function transition_transition() {
  var name = this._name, id0 = this._id, id1 = newId();
  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit2 = get(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit2.time + inherit2.delay + inherit2.duration,
          delay: 0,
          duration: inherit2.duration,
          ease: inherit2.ease
        });
      }
    }
  }
  return new Transition(groups, this._parents, name, id1);
}
function transition_end() {
  var on0, on1, that = this, id2 = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = { value: reject }, end = { value: function() {
      if (--size === 0)
        resolve();
    } };
    that.each(function() {
      var schedule2 = set(this, id2), on = schedule2.on;
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }
      schedule2.on = on1;
    });
    if (size === 0)
      resolve();
  });
}
var id = 0;
function Transition(groups, parents, name, id2) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id2;
}
function newId() {
  return ++id;
}
var selection_prototype = selection.prototype;
Transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  selectChild: selection_prototype.selectChild,
  selectChildren: selection_prototype.selectChildren,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  easeVarying: transition_easeVarying,
  end: transition_end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};
function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var defaultTiming = {
  time: null,
  delay: 0,
  duration: 250,
  ease: cubicInOut
};
function inherit(node, id2) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id2])) {
    if (!(node = node.parentNode)) {
      throw new Error(`transition ${id2} not found`);
    }
  }
  return timing;
}
function selection_transition(name) {
  var id2, timing;
  if (name instanceof Transition) {
    id2 = name._id, name = name._name;
  } else {
    id2 = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }
  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id2, i, group, timing || inherit(node, id2));
      }
    }
  }
  return new Transition(groups, this._parents, name, id2);
}
selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
  this._ += strings[0];
  for (let i = 1, n = strings.length; i < n; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  let d = Math.floor(digits);
  if (!(d >= 0))
    throw new Error(`invalid digits: ${digits}`);
  if (d > 15)
    return append;
  const k = 10 ** d;
  return function(strings) {
    this._ += strings[0];
    for (let i = 1, n = strings.length; i < n; ++i) {
      this._ += Math.round(arguments[i] * k) / k + strings[i];
    }
  };
}
class Path {
  constructor(digits) {
    this._x0 = this._y0 = this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x2, y2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x2, y2) {
    this._append`L${this._x1 = +x2},${this._y1 = +y2}`;
  }
  quadraticCurveTo(x1, y1, x2, y2) {
    this._append`Q${+x1},${+y1},${this._x1 = +x2},${this._y1 = +y2}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x3},${this._y1 = +y3}`;
  }
  arcTo(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    if (r < 0)
      throw new Error(`negative radius: ${r}`);
    let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon))
      ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
      if (Math.abs(t01 - 1) > epsilon) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x2, y2, r, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r = +r, ccw = !!ccw;
    if (r < 0)
      throw new Error(`negative radius: ${r}`);
    let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x2 + dx, y0 = y2 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._append`L${x0},${y0}`;
    }
    if (!r)
      return;
    if (da < 0)
      da = da % tau + tau;
    if (da > tauEpsilon) {
      this._append`A${r},${r},0,1,${cw},${x2 - dx},${y2 - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da > epsilon) {
      this._append`A${r},${r},0,${+(da >= pi)},${cw},${this._x1 = x2 + r * Math.cos(a1)},${this._y1 = y2 + r * Math.sin(a1)}`;
    }
  }
  rect(x2, y2, w, h) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}h${w = +w}v${+h}h${-w}Z`;
  }
  toString() {
    return this._;
  }
}
function formatDecimal(x2) {
  return Math.abs(x2 = Math.round(x2)) >= 1e21 ? x2.toLocaleString("en").replace(/,/g, "") : x2.toString(10);
}
function formatDecimalParts(x2, p) {
  if ((i = (x2 = p ? x2.toExponential(p - 1) : x2.toExponential()).indexOf("e")) < 0)
    return null;
  var i, coefficient = x2.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x2.slice(i + 1)
  ];
}
function exponent(x2) {
  return x2 = formatDecimalParts(Math.abs(x2)), x2 ? x2[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
    while (i > 0 && g > 0) {
      if (length + g + 1 > width)
        g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width)
        break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier)))
    throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s) {
  out:
    for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
      switch (s[i]) {
        case ".":
          i0 = i1 = i;
          break;
        case "0":
          if (i0 === 0)
            i0 = i;
          i1 = i;
          break;
        default:
          if (!+s[i])
            break out;
          if (i0 > 0)
            i0 = 0;
          break;
      }
    }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
var prefixExponent;
function formatPrefixAuto(x2, p) {
  var d = formatDecimalParts(x2, p);
  if (!d)
    return x2 + "";
  var coefficient = d[0], exponent2 = d[1], i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x2, Math.max(0, p + i - 1))[0];
}
function formatRounded(x2, p) {
  var d = formatDecimalParts(x2, p);
  if (!d)
    return x2 + "";
  var coefficient = d[0], exponent2 = d[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
const formatTypes = {
  "%": (x2, p) => (x2 * 100).toFixed(p),
  "b": (x2) => Math.round(x2).toString(2),
  "c": (x2) => x2 + "",
  "d": formatDecimal,
  "e": (x2, p) => x2.toExponential(p),
  "f": (x2, p) => x2.toFixed(p),
  "g": (x2, p) => x2.toPrecision(p),
  "o": (x2) => Math.round(x2).toString(8),
  "p": (x2, p) => formatRounded(x2 * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x2) => Math.round(x2).toString(16).toUpperCase(),
  "x": (x2) => Math.round(x2).toString(16)
};
function identity$1(x2) {
  return x2;
}
var map = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale(locale2) {
  var group = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$1 : formatGroup(map.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$1 : formatNumerals(map.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "\u2212" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero2 = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
    if (type === "n")
      comma = true, type = "g";
    else if (!formatTypes[type])
      precision === void 0 && (precision = 12), trim = true, type = "g";
    if (zero2 || fill === "0" && align === "=")
      zero2 = true, fill = "0", align = "=";
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
    var formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim)
          value = formatTrim(value);
        if (valueNegative && +value === 0 && sign !== "+")
          valueNegative = false;
        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero2)
        value = group(value, Infinity);
      var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
      if (comma && zero2)
        value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
    return function(value2) {
      return f(k * value2) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}
function precisionRound(step, max2) {
  step = Math.abs(step), max2 = Math.abs(max2) - step;
  return Math.max(0, exponent(max2) - exponent(step)) + 1;
}
function initRange(domain, range) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range).domain(domain);
      break;
  }
  return this;
}
function constants(x2) {
  return function() {
    return x2;
  };
}
function number(x2) {
  return +x2;
}
var unit = [0, 1];
function identity(x2) {
  return x2;
}
function normalize(a, b) {
  return (b -= a = +a) ? function(x2) {
    return (x2 - a) / b;
  } : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
  var t;
  if (a > b)
    t = a, a = b, b = t;
  return function(x2) {
    return Math.max(a, Math.min(b, x2));
  };
}
function bimap(domain, range, interpolate2) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0)
    d0 = normalize(d1, d0), r0 = interpolate2(r1, r0);
  else
    d0 = normalize(d0, d1), r0 = interpolate2(r0, r1);
  return function(x2) {
    return r0(d0(x2));
  };
}
function polymap(domain, range, interpolate2) {
  var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate2(range[i], range[i + 1]);
  }
  return function(x2) {
    var i2 = bisect(domain, x2, 1, j) - 1;
    return r[i2](d[i2](x2));
  };
}
function copy(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
  var domain = unit, range = unit, interpolate2 = interpolate$1, transform, untransform, unknown, clamp = identity, piecewise, output, input;
  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity)
      clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate2)))(transform(clamp(x2)));
  }
  scale.invert = function(y2) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y2)));
  };
  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number), rescale()) : domain.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };
  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate2 = interpolateRound, rescale();
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
  };
  scale.interpolate = function(_) {
    return arguments.length ? (interpolate2 = _, rescale()) : interpolate2;
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer()(identity, identity);
}
function tickFormat(start2, stop, count, specifier) {
  var step = tickStep(start2, stop, count), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start2), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value)))
        specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start2), Math.abs(stop)))))
        specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step)))
        specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}
function linearish(scale) {
  var domain = scale.domain;
  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };
  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };
  scale.nice = function(count) {
    if (count == null)
      count = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start2 = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start2) {
      step = start2, start2 = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start2, stop, count);
      if (step === prestep) {
        d[i0] = start2;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start2 = Math.floor(start2 / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start2 = Math.ceil(start2 * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function constant(x2) {
  return function constant2() {
    return x2;
  };
}
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_) {
    if (!arguments.length)
      return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d = Math.floor(_);
      if (!(d >= 0))
        throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    return shape;
  };
  return () => new Path(digits);
}
function array(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(x2, y2);
        break;
    }
  }
};
function curveLinear(context) {
  return new Linear(context);
}
function x(p) {
  return p[0];
}
function y(p) {
  return p[1];
}
function line(x$1, y$1) {
  var defined = constant(true), context = null, curve = curveLinear, output = null, path = withPath(line2);
  x$1 = typeof x$1 === "function" ? x$1 : x$1 === void 0 ? x : constant(x$1);
  y$1 = typeof y$1 === "function" ? y$1 : y$1 === void 0 ? y : constant(y$1);
  function line2(data) {
    var i, n = (data = array(data)).length, d, defined0 = false, buffer;
    if (context == null)
      output = curve(buffer = path());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0)
          output.lineStart();
        else
          output.lineEnd();
      }
      if (defined0)
        output.point(+x$1(d, i, data), +y$1(d, i, data));
    }
    if (buffer)
      return output = null, buffer + "" || null;
  }
  line2.x = function(_) {
    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line2) : x$1;
  };
  line2.y = function(_) {
    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line2) : y$1;
  };
  line2.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line2) : defined;
  };
  line2.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line2) : curve;
  };
  line2.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line2) : context;
  };
  return line2;
}
function area(x0, y0, y1) {
  var x1 = null, defined = constant(true), context = null, curve = curveLinear, output = null, path = withPath(area2);
  x0 = typeof x0 === "function" ? x0 : x0 === void 0 ? x : constant(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === void 0 ? constant(0) : constant(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === void 0 ? y : constant(+y1);
  function area2(data) {
    var i, j, k, n = (data = array(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
    if (context == null)
      output = curve(buffer = path());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }
    if (buffer)
      return output = null, buffer + "" || null;
  }
  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }
  area2.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area2) : x0;
  };
  area2.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area2) : x0;
  };
  area2.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area2) : x1;
  };
  area2.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area2) : y0;
  };
  area2.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area2) : y0;
  };
  area2.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area2) : y1;
  };
  area2.lineX0 = area2.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };
  area2.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };
  area2.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };
  area2.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area2) : defined;
  };
  area2.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area2) : curve;
  };
  area2.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area2) : context;
  };
  return area2;
}
function point(that, x2, y2) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x2) / 6,
    (that._y0 + 4 * that._y1 + y2) / 6
  );
}
function Basis(context) {
  this._context = context;
}
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        point(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function curveBasis(context) {
  return new Basis(context);
}
function Transform(k, x2, y2) {
  this.k = k;
  this.x = x2;
  this.y = y2;
}
Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x2, y2) {
    return x2 === 0 & y2 === 0 ? this : new Transform(this.k, this.x + this.k * x2, this.y + this.k * y2);
  },
  apply: function(point2) {
    return [point2[0] * this.k + this.x, point2[1] * this.k + this.y];
  },
  applyX: function(x2) {
    return x2 * this.k + this.x;
  },
  applyY: function(y2) {
    return y2 * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x2) {
    return (x2 - this.x) / this.k;
  },
  invertY: function(y2) {
    return (y2 - this.y) / this.k;
  },
  rescaleX: function(x2) {
    return x2.copy().domain(x2.range().map(this.invertX, this).map(x2.invert, x2));
  },
  rescaleY: function(y2) {
    return y2.copy().domain(y2.range().map(this.invertY, this).map(y2.invert, y2));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
new Transform(1, 0, 0);
Transform.prototype;
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1ifxucn",
  styles: "min-width:328px;max-width:1024px;position:relative"
} : {
  name: "d2rqmt-container",
  styles: "min-width:328px;max-width:1024px;position:relative;label:container;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const container = () => _ref2;
var _ref = process.env.NODE_ENV === "production" ? {
  name: "jk7dkw",
  styles: "width:100%;max-width:100%"
} : {
  name: "8tnqk3-chart",
  styles: "width:100%;max-width:100%;label:chart;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const chart = () => _ref;
const tooltipBase = (theme) => /* @__PURE__ */ css("min-width:94px;position:absolute;text-align:center;background:", theme.ascend.colors.neutral[0], ";font-family:'Ultramarine';box-shadow:0px 15px 40px -5px #52525242;font-weight:500;border:0px;border-radius:5px;pointer-events:none;opacity:0;.title{font-size:13px;border-radius:5px 5px 0 0;padding:5px;display:flex;gap:5px;align-items:center;justify-content:center;border:1px solid ", theme.ascend.colors.border.opaque, ";img{width:", theme.spacing(2.5), ";height:", theme.spacing(2), ";}}.value{padding:", theme.spacing(1), ";font-size:15px;}::after{content:'';position:absolute;border-width:", theme.spacing(2), ";border-style:solid;margin-left:", theme.spacing(1), ";top:90%;left:20%;border-color:", theme.ascend.colors.neutral[0], " ", theme.ascend.colors.neutral[0], " transparent transparent;transform:rotate(-90deg);}" + (process.env.NODE_ENV === "production" ? "" : ";label:tooltipBase;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const tooltipAchieve = (theme) => /* @__PURE__ */ css(".title{border:0px;background:", theme.ascend.colors.blue[500], ";color:", theme.ascend.colors.neutral[0], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:tooltipAchieve;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const tooltipCurrent = (theme) => /* @__PURE__ */ css(".title{background:", theme.ascend.colors.border.opaque, ";color:", theme.ascend.colors.content.secondary, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:tooltipCurrent;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2NpcmNsZWNpL3Byb2plY3QvcGFja2FnZXMvdWktbW9kdWxlcy9jeC1kZWJ0LWFzc2Vzc21lbnQtZ3JhcGgvc3JjL2NvbXBvbmVudHMvRGF0R3JhcGgvRGF0R3JhcGguc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFFbUQiLCJmaWxlIjoiL2hvbWUvY2lyY2xlY2kvcHJvamVjdC9wYWNrYWdlcy91aS1tb2R1bGVzL2N4LWRlYnQtYXNzZXNzbWVudC1ncmFwaC9zcmMvY29tcG9uZW50cy9EYXRHcmFwaC9EYXRHcmFwaC5zdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgY29udGFpbmVyID0gKCkgPT4gY3NzYFxuICBtaW4td2lkdGg6IDMyOHB4O1xuICBtYXgtd2lkdGg6IDEwMjRweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuYDtcblxuZXhwb3J0IGNvbnN0IGNoYXJ0ID0gKCkgPT4gY3NzYFxuICB3aWR0aDogMTAwJTtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuYDtcblxuZXhwb3J0IGNvbnN0IHRvb2x0aXBCYXNlID0gKHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICBtaW4td2lkdGg6IDk0cHg7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBiYWNrZ3JvdW5kOiAke3RoZW1lLmFzY2VuZC5jb2xvcnMubmV1dHJhbFswXX07XG4gIGZvbnQtZmFtaWx5OiAnVWx0cmFtYXJpbmUnO1xuICBib3gtc2hhZG93OiAwcHggMTVweCA0MHB4IC01cHggIzUyNTI1MjQyO1xuICBmb250LXdlaWdodDogNTAwO1xuICBib3JkZXI6IDBweDtcbiAgYm9yZGVyLXJhZGl1czogNXB4O1xuICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgb3BhY2l0eTogMDtcblxuICAudGl0bGUge1xuICAgIGZvbnQtc2l6ZTogMTNweDtcbiAgICBib3JkZXItcmFkaXVzOiA1cHggNXB4IDAgMDtcbiAgICBwYWRkaW5nOiA1cHg7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBnYXA6IDVweDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGJvcmRlcjogMXB4IHNvbGlkICR7dGhlbWUuYXNjZW5kLmNvbG9ycy5ib3JkZXIub3BhcXVlfTtcblxuICAgIGltZyB7XG4gICAgICB3aWR0aDogJHt0aGVtZS5zcGFjaW5nKDIuNSl9O1xuICAgICAgaGVpZ2h0OiAke3RoZW1lLnNwYWNpbmcoMil9O1xuICAgIH1cbiAgfVxuXG4gIC52YWx1ZSB7XG4gICAgcGFkZGluZzogJHt0aGVtZS5zcGFjaW5nKDEpfTtcbiAgICBmb250LXNpemU6IDE1cHg7XG4gIH1cblxuICA6OmFmdGVyIHtcbiAgICBjb250ZW50OiAnJztcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgYm9yZGVyLXdpZHRoOiAke3RoZW1lLnNwYWNpbmcoMil9O1xuICAgIGJvcmRlci1zdHlsZTogc29saWQ7XG4gICAgbWFyZ2luLWxlZnQ6ICR7dGhlbWUuc3BhY2luZygxKX07XG4gICAgdG9wOiA5MCU7XG4gICAgbGVmdDogMjAlO1xuICAgIGJvcmRlci1jb2xvcjogJHt0aGVtZS5hc2NlbmQuY29sb3JzLm5ldXRyYWxbMF19XG4gICAgICAke3RoZW1lLmFzY2VuZC5jb2xvcnMubmV1dHJhbFswXX0gdHJhbnNwYXJlbnQgdHJhbnNwYXJlbnQ7XG4gICAgdHJhbnNmb3JtOiByb3RhdGUoLTkwZGVnKTtcbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IHRvb2x0aXBBY2hpZXZlID0gKHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAudGl0bGUge1xuICAgIGJvcmRlcjogMHB4O1xuICAgIGJhY2tncm91bmQ6ICR7dGhlbWUuYXNjZW5kLmNvbG9ycy5ibHVlWzUwMF19O1xuICAgIGNvbG9yOiAke3RoZW1lLmFzY2VuZC5jb2xvcnMubmV1dHJhbFswXX07XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCB0b29sdGlwQ3VycmVudCA9ICh0aGVtZTogVGhlbWUpID0+IGNzc2BcbiAgLnRpdGxlIHtcbiAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmFzY2VuZC5jb2xvcnMuYm9yZGVyLm9wYXF1ZX07XG4gICAgY29sb3I6ICR7dGhlbWUuYXNjZW5kLmNvbG9ycy5jb250ZW50LnNlY29uZGFyeX07XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCB0b29sdGlwV2FpdCA9ICh0aGVtZTogVGhlbWUpID0+IGNzc2BcbiAgLnRpdGxlIHtcbiAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmFzY2VuZC5jb2xvcnMuYmFja2dyb3VuZC5yZWR9O1xuICAgIGNvbG9yOiAke3RoZW1lLmFzY2VuZC5jb2xvcnMucmVkWyc0MDAnXX07XG4gIH1cbmA7XG4iXX0= */");
const tooltipWait = (theme) => /* @__PURE__ */ css(".title{background:", theme.ascend.colors.background.red, ";color:", theme.ascend.colors.red["400"], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:tooltipWait;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const DatGraph = ({
  graphHeight = 350,
  data = DataSectionTest,
  textLegendAxisY = "TOTAL",
  subtextLegendAxisY = "COST",
  achieveLogo = "https://images.ctfassets.net/80jeq2aeq4l1/1h9tWFoBq4p7v3Y9c9HzXs/11bae295d59e2128f9143e4d95b61441/a_logo.svg?w=3840",
  tooltipTitleAchieve = "achieve",
  tooltipPositionAchieve = "left",
  tooltipTitleCurrent = "Current",
  tooltipPositionCurrent = "right",
  tooltipTitleWait = "If you wait",
  tooltipPositionWait = "middle",
  productType = "AR",
  productTypeTerms = 0,
  simpleYaxis = false,
  colorGraph = "",
  lineAchieveStyle = "solid",
  lineCurrentStyle = "solid",
  lineWaitStyle = "solid",
  curveLevelAchieve = 1,
  curveLevelCurrent = 3,
  curveLevelWait = 3,
  showAchieve = true,
  showCurrent = true,
  showWait = true,
  lineOffsetAchieveX = 0,
  lineOffsetCurrentX = 0,
  lineOffsetWaitX = 1,
  lineOffsetAchieveY = 0,
  lineOffsetCurrentY = 0,
  lineOffsetWaitY = -2,
  showAchieveTooltip = true,
  showCurrentTooltip = true,
  showWaitTooltip = true
}) => {
  const theme = useTheme();
  const refContainer = useRef(null);
  const refChartSvg = useRef(null);
  const tooltipRefAchieve = useRef(null);
  const tooltipRefCurrent = useRef(null);
  const tooltipRefWait = useRef(null);
  const [graphWidth, setGraphWidth] = useState(0);
  const [svgChart, setSvgChart] = useState(null);
  const MARGIN = {
    top: 10,
    right: 30,
    bottom: 20,
    left: 50
  };
  const pathToPoints = (pathData) => {
    const commands = pathData.match(/[a-df-z]|[\d.]+/gi);
    const points = [];
    let currentX = 0;
    let currentY = 0;
    commands == null ? void 0 : commands.forEach((command, index) => {
      if (command === "M") {
        currentX = parseFloat(commands[index + 1]);
        currentY = parseFloat(commands[index + 2]);
        points.push([currentX, currentY]);
      } else if (command === "L") {
        currentX = parseFloat(commands[index + 1]);
        currentY = parseFloat(commands[index + 2]);
        points.push([currentX, currentY]);
      } else if (command === "C") {
        currentX = parseFloat(commands[index + 5]);
        currentY = parseFloat(commands[index + 6]);
        points.push([currentX, currentY]);
      }
    });
    return points;
  };
  const addTooltip = function({
    title,
    titleIcon,
    value,
    xAdd,
    yAdd,
    tooltipRef,
    lineClassname,
    position = "middle",
    showTooltip
  }) {
    const pathElement = document.getElementsByClassName(lineClassname)[0];
    const pathData = pathElement == null ? void 0 : pathElement.getAttribute("d");
    const points = pathToPoints(pathData || "");
    let pointOfRender;
    switch (position) {
      case "left":
        pointOfRender = 1;
        break;
      case "right":
        pointOfRender = 5;
        break;
      case "middle":
        pointOfRender = 3;
        break;
      default:
        pointOfRender = +position;
        break;
    }
    let xOffsetRender = 25 + xAdd;
    let yOffsetRender = -77 + yAdd;
    if (pointOfRender === 1) {
      xOffsetRender = 50 + xAdd;
      yOffsetRender = graphWidth > 377 ? -77 + yAdd : -75 + yAdd;
    }
    const [x2, y2] = points[pointOfRender];
    const tooltipDiv = tooltipRef.current;
    if (tooltipDiv && showTooltip) {
      select(tooltipDiv).transition().duration(200).style("opacity", 1);
      select(tooltipDiv).html(`
          <div class='title'>
          ${titleIcon ? `<img alt="Achieve logo" width="20" height="16" src='${achieveLogo}'/>` : ""}
          ${title}
          </div>
          <div class='value'>${value}</div>
          `).style("left", x2 + xOffsetRender + "px").style("top", y2 + yOffsetRender + "px");
    }
  };
  const addGridLines = (width, height, svg) => {
    const y2 = linear().range([height, 0]);
    const yAxisGrid = axisRight(y2).tickSize(width).tickFormat("").ticks(4);
    const axisG = svg.append("g").call(yAxisGrid);
    axisG.selectAll("line").attr("stroke", theme.ascend.colors.border.opaque).attr("stroke", (d, i) => i == 0 ? "none" : theme.ascend.colors.border.opaque);
    axisG.selectAll("path").attr("stroke", "none");
  };
  const getStrokeDashArray = (style) => {
    switch (style) {
      case "solid":
        return "none";
      case "dashed":
        return "10,10";
      case "dotted":
        return "1,6";
      default:
        return "none";
    }
  };
  const getXYvalue = (yInitial, xInitial, i, curveLevel) => {
    const m = yInitial / xInitial;
    const x2 = +(xInitial / 5) * i;
    const curveCorrection = curveLevel > 0 ? i / (5 + curveLevel) : 1;
    const y2 = -(m * curveCorrection) * x2 + yInitial;
    return {
      x: x2,
      y: y2
    };
  };
  const interpolatePointsAchieveDebt = (point1, point2) => {
    const interpolatedPoints = [{
      ...point1
    }];
    for (let i = 1; i < 5; i++) {
      const {
        x: achieveYears,
        y: achieveDebt
      } = getXYvalue(point1.achieveDebt, point2.achieveYears, i, curveLevelAchieve);
      const {
        x: currentYears,
        y: currentDebt
      } = getXYvalue(point1.currentDebt, point2.currentYears, i, curveLevelCurrent);
      const {
        x: waitYears,
        y: waitDebt
      } = getXYvalue(point1.waitDebt, point2.waitYears, i, curveLevelWait);
      interpolatedPoints.push({
        achieveDebt,
        achieveYears,
        currentDebt,
        currentYears,
        waitDebt,
        waitYears
      });
    }
    interpolatedPoints.push({
      ...point2
    });
    return interpolatedPoints;
  };
  const getGraphData = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
    if (data && data.achieveOffer && data.currentOffer && data.waitOffer) {
      return {
        achieveOffer: {
          ...data.achieveOffer
        },
        currentOffer: {
          ...data.currentOffer
        },
        waitOffer: {
          ...data.waitOffer
        }
      };
    }
    let achieveOffer = {
      totalCost: 0,
      monthlyPayment: 0,
      years: 0
    }, idxOffer, offersAvailable;
    switch (productType) {
      case "AR":
        idxOffer = 1;
        offersAvailable = (_a = data == null ? void 0 : data.default_offers) == null ? void 0 : _a.ar_offers;
        break;
      case "PL":
        idxOffer = 1;
        offersAvailable = (_b = data == null ? void 0 : data.default_offers) == null ? void 0 : _b.apl_offers;
        break;
      case "HL":
        idxOffer = 0;
        offersAvailable = (_c = data == null ? void 0 : data.default_offers) == null ? void 0 : _c.ahl_offers;
        break;
    }
    if (productTypeTerms) {
      const idxFound = (offersAvailable == null ? void 0 : offersAvailable.map((i) => i == null ? void 0 : i.terms).indexOf(productTypeTerms)) || -1;
      if (idxFound >= 0)
        idxOffer = idxFound;
    }
    offersAvailable = offersAvailable == null ? void 0 : offersAvailable[idxOffer];
    achieveOffer = {
      totalCost: (offersAvailable == null ? void 0 : offersAvailable.total_cost) || 0,
      monthlyPayment: (offersAvailable == null ? void 0 : offersAvailable.monthly_payment) || 0,
      years: Math.round(((offersAvailable == null ? void 0 : offersAvailable.terms) || 0) / 12)
    };
    const currentOffer = {
      totalCost: Math.round(((_g = (_f = (_e = (_d = data == null ? void 0 : data.current_assessment) == null ? void 0 : _d.cfos) == null ? void 0 : _e.payoff_plans) == null ? void 0 : _f[0]) == null ? void 0 : _g.total_amount) || 0),
      monthlyPayment: Math.round(((_k = (_j = (_i = (_h = data == null ? void 0 : data.current_assessment) == null ? void 0 : _h.cfos) == null ? void 0 : _i.payoff_plans) == null ? void 0 : _j[0]) == null ? void 0 : _k.starting_total_monthly_payment) || 0),
      years: Math.round((((_o = (_n = (_m = (_l = data == null ? void 0 : data.current_assessment) == null ? void 0 : _l.cfos) == null ? void 0 : _m.payoff_plans) == null ? void 0 : _n[0]) == null ? void 0 : _o.time_in_months) || 0) / 12)
    };
    const waitOffer = {
      totalCost: Math.round(((_s = (_r = (_q = (_p = data == null ? void 0 : data.projected_assessment) == null ? void 0 : _p.cfos) == null ? void 0 : _q.payoff_plans) == null ? void 0 : _r[0]) == null ? void 0 : _s.total_amount) || 0),
      monthlyPayment: Math.round(((_w = (_v = (_u = (_t = data == null ? void 0 : data.projected_assessment) == null ? void 0 : _t.cfos) == null ? void 0 : _u.payoff_plans) == null ? void 0 : _v[0]) == null ? void 0 : _w.starting_total_monthly_payment) || 0),
      years: Math.round((((_A = (_z = (_y = (_x = data == null ? void 0 : data.projected_assessment) == null ? void 0 : _x.cfos) == null ? void 0 : _y.payoff_plans) == null ? void 0 : _z[0]) == null ? void 0 : _A.time_in_months) || 0) / 12)
    };
    return {
      achieveOffer,
      currentOffer,
      waitOffer
    };
  };
  const createGraph = async () => {
    let dataPoints = [];
    const {
      achieveOffer,
      currentOffer,
      waitOffer
    } = getGraphData();
    if (achieveOffer && currentOffer && waitOffer) {
      dataPoints = interpolatePointsAchieveDebt({
        achieveDebt: achieveOffer.totalCost,
        achieveYears: 0,
        currentDebt: currentOffer.totalCost,
        currentYears: 0,
        waitDebt: waitOffer.totalCost,
        waitYears: 0
      }, {
        achieveDebt: 0,
        achieveYears: achieveOffer.years,
        currentDebt: 0,
        currentYears: currentOffer.years,
        waitDebt: 0,
        waitYears: waitOffer.years
      });
    } else
      return;
    const maxValue = Math.ceil(Math.max(...dataPoints.map((i) => Math.max(i.achieveDebt, i.currentDebt, i.waitDebt))) * 1.1 / 1e4) * 1e4;
    const margin = MARGIN, width = graphWidth - margin.left - margin.right, height = graphHeight - margin.top - margin.bottom;
    if (svgChart)
      svgChart.remove();
    const svg = select(refChartSvg.current).append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", `translate(${margin.left}, ${margin.top})`);
    const x2 = linear().range([0, width]);
    const y2 = linear().range([height, 0]);
    x2.domain([0, max(dataPoints, (d) => {
      return Math.max(...[d.achieveYears, d.currentYears, d.waitYears]) + 1;
    })]);
    y2.domain([0, Math.ceil(maxValue * 1.1 / 1e3) * 1e3]);
    setSvgChart(svg);
    if (colorGraph)
      svg.append("rect").attr("width", width).attr("height", height).attr("fill", colorGraph);
    const axisX = svg.append("g").attr("transform", `translate(0, ${height})`).call(axisBottom(x2).ticks(4).tickFormat((d) => {
      return `${d}yr`;
    }));
    axisX.selectAll("line").attr("stroke", "none");
    axisX.selectAll("path").attr("stroke", theme.ascend.colors.border.primary).attr("stroke-width", 2);
    axisX.selectAll("text").attr("color", theme.ascend.colors.neutral[150]).attr("font-weight", "700").attr("font-size", "10px").attr("font-family", "Ultramarine");
    const axisY = svg.append("g").call(axisLeft(y2).ticks(4).tickFormat((d, i) => {
      var _a;
      if (i === 4)
        return subtextLegendAxisY;
      if (i === 5)
        return textLegendAxisY;
      return typeof d === "number" ? d === 0 ? "" : ((_a = refChartSvg == null ? void 0 : refChartSvg.current) == null ? void 0 : _a.clientWidth) <= 365 ? simpleYaxis ? "$".repeat(i) : numberFormatThousands(d) : simpleYaxis ? "$".repeat(i) : numberFormatCurrency(d) : d;
    }).tickValues([0, Math.ceil(maxValue * 0.1 / 1e4) * 1e4, Math.ceil(maxValue * 0.5 / 1e4) * 1e4, maxValue, maxValue * 1.1, maxValue * 1.09]));
    axisY.selectAll("line").attr("stroke", "none");
    axisY.selectAll("path").attr("stroke", theme.ascend.colors.border.primary).attr("stroke-width", 2);
    axisY.selectAll("text").attr("color", theme.ascend.colors.neutral[150]).attr("font-weight", "500").attr("font-size", "10px").attr("font-family", "Ultramarine");
    axisY.selectAll("text").filter((d) => {
      return d == maxValue * 1.09;
    }).attr("font-size", "9px").attr("text-align", "right").attr("dy", "-5");
    axisY.selectAll("text").filter((d) => {
      return d == maxValue * 1.1;
    }).attr("font-size", "9px").attr("text-align", "right").attr("dy", "7");
    const curvex = curveBasis;
    addGridLines(width, height, svg);
    if (showAchieve) {
      const valueLine = line().x((d) => {
        return x2(d.achieveYears);
      }).y((d) => {
        return y2(d.achieveDebt);
      }).curve(curvex);
      svg.append("path").data([dataPoints]).attr("class", "chartLine1").attr("fill", "none").attr("stroke", theme.ascend.colors.blue[500]).attr("stroke-width", 3).attr("stroke-linecap", "round").attr("d", valueLine).style("stroke-dasharray", getStrokeDashArray(lineAchieveStyle));
      const valueArea = area().x((d) => {
        return x2(d.achieveYears);
      }).y0(y2(0)).y1((d) => {
        return y2(d.achieveDebt);
      }).curve(curvex);
      svg.append("path").data([dataPoints]).attr("fill-opacity", "0.15").attr("fill", theme.ascend.colors.blue[500]).attr("d", valueArea);
      addTooltip({
        title: tooltipTitleAchieve,
        titleIcon: true,
        value: `${numberFormatCurrency(achieveOffer.monthlyPayment)}/mo`,
        xAdd: lineOffsetAchieveX,
        yAdd: lineOffsetAchieveY,
        tooltipRef: tooltipRefAchieve,
        lineClassname: "chartLine1",
        position: tooltipPositionAchieve,
        showTooltip: showAchieveTooltip
      });
    }
    if (showCurrent) {
      const valueLine2 = line().x((d) => {
        return x2(d.currentYears);
      }).y((d) => {
        return y2(d.currentDebt);
      }).curve(curvex);
      svg.append("path").data([dataPoints]).attr("class", "chartLine2").attr("fill", "none").attr("stroke", theme.ascend.colors.border.primary).attr("stroke-width", 3).attr("stroke-linecap", "round").attr("d", valueLine2).style("stroke-dasharray", getStrokeDashArray(lineCurrentStyle));
      addTooltip({
        title: tooltipTitleCurrent,
        value: `${numberFormatCurrency(currentOffer.monthlyPayment)}/mo`,
        xAdd: lineOffsetCurrentX,
        yAdd: lineOffsetCurrentY,
        tooltipRef: tooltipRefCurrent,
        lineClassname: "chartLine2",
        position: tooltipPositionCurrent,
        showTooltip: showCurrentTooltip
      });
    }
    if (!showWait)
      return;
    const valueLine3 = line().x((d) => {
      return x2(d.waitYears);
    }).y((d) => {
      return y2(d.waitDebt);
    }).curve(curvex);
    svg.append("path").data([dataPoints]).attr("class", "chartLine3").attr("fill", "none").attr("stroke", theme.palette.error.main).attr("stroke-width", 3).attr("stroke-linecap", "round").attr("d", valueLine3).style("stroke-dasharray", getStrokeDashArray(lineWaitStyle));
    addTooltip({
      title: tooltipTitleWait,
      value: `${numberFormatCurrency(waitOffer.monthlyPayment)}/mo`,
      xAdd: lineOffsetWaitX,
      yAdd: lineOffsetWaitY,
      tooltipRef: tooltipRefWait,
      lineClassname: "chartLine3",
      position: tooltipPositionWait,
      showTooltip: showWaitTooltip
    });
  };
  useEffect(() => {
    if (graphWidth > 0 && data)
      createGraph();
  }, [graphWidth, graphHeight, data]);
  useLayoutEffect(() => {
    const setContainerWidth = () => {
      var _a;
      if (refChartSvg.current !== null) {
        setGraphWidth((_a = refContainer == null ? void 0 : refContainer.current) == null ? void 0 : _a.clientWidth);
      }
    };
    if (graphWidth === 0)
      setContainerWidth();
    window.addEventListener("resize", setContainerWidth);
    return () => {
      window.removeEventListener("resize", setContainerWidth);
    };
  }, []);
  return /* @__PURE__ */ jsxs(Box, { css: container, ref: refContainer, children: [
    /* @__PURE__ */ jsx("svg", { css: chart, height: graphHeight, id: "barchart", ref: refChartSvg }),
    showAchieveTooltip && /* @__PURE__ */ jsx("div", { css: [tooltipBase, tooltipAchieve, process.env.NODE_ENV === "production" ? "" : ";label:DatGraph;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], ref: tooltipRefAchieve, "data-testid": "tooltip-Achieve" }),
    showCurrentTooltip && /* @__PURE__ */ jsx("div", { css: [tooltipBase, tooltipCurrent, process.env.NODE_ENV === "production" ? "" : ";label:DatGraph;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], ref: tooltipRefCurrent, "data-testid": "tooltip-Current" }),
    showWaitTooltip && /* @__PURE__ */ jsx("div", { css: [tooltipBase, tooltipWait, process.env.NODE_ENV === "production" ? "" : ";label:DatGraph;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], ref: tooltipRefWait, "data-testid": "tooltip-Wait" })
  ] });
};
export {
  DatGraph
};
//# sourceMappingURL=index.es.js.map
